import React, { useEffect } from "react";
import {
	createBrowserRouter,
	useLocation,
	useNavigate,
} from "react-router-dom";
import { MainApp } from "../components/MainApp";
import { useApp } from "../components/AppContext";

// Auth Guard Component - Protects routes that require authentication
const AuthGuard = ({ children }: { children: React.ReactNode }) => {
	const { isAuthenticated } = useApp();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		// If not authenticated and trying to access protected route, redirect to login
		// Allow /auth/* routes and /reset-password for password reset
		if (
			!isAuthenticated &&
			!location.pathname.startsWith("/auth") &&
			!location.pathname.startsWith("/reset-password")
		) {
			navigate("/auth/signin", { replace: true });
		}
	}, [isAuthenticated, location.pathname, navigate]);

	return <>{children}</>;
};

// For now, we'll use MainApp as the main component and let it handle the routing
// This allows for a gradual migration
const AppWrapper = () => {
	return (
		<AuthGuard>
			<MainApp />
		</AuthGuard>
	);
};

export const router = createBrowserRouter(
	[
		{
			path: "/*",
			element: <AppWrapper />,
		},
	],
	{
		future: {
			// Enable v7 future flags to prepare for migration and remove warnings
			v7_startTransition: true,
			v7_fetcherPersist: true,
			v7_normalizeFormMethod: true,
			v7_partialHydration: true,
			v7_relativeSplatPath: true,
			v7_skipActionErrorRevalidation: true,
		} as any, // Type assertion to handle version differences between types and runtime
	}
);
